import { addDays, parseISO } from "date-fns";
import { formatInTimeZone  } from "date-fns-tz";
import config from '../config';

export function getXsrfToken() {
  const match = document.cookie.match(/(^|;\s*)XSRF-TOKEN=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : null;
}

export async function handleJsonResponse(response) {
  if(response.status === 400)
  {
    const errorDetail = await response.json()
    const error = new Error('Bad Request');
    error.status = 400;
    error.detail = errorDetail;
    throw error;
  }

  handleResponse(response);
  if (response.status === 204) {
    return null; // No content to parse
  }
  
  return response.json();
    
}

export function handleFileUploadResponse(response) {
  handleResponse(response);
}

export function getFilterQuery(filters) {

  
  const filterKeys = Object.keys(filters);
  const filterQueries = filterKeys.map((key) => {
    const filterValue = filters[key];
    
    if(filterValue.operator)
    { 
      const conditions = filterValue.conditions
      conditions.map((condition) => {
        
        const additionalFilter = createConditionQuery(condition, key)
        return additionalFilter;
      })
    }
    else if (key === 'metadata')
    {
      return filterValue.filter
    }
    else
    {
      if (filterValue.filter == null || filterValue.filter === "") {
        return undefined;
      }
      const additionalFilter = createConditionQuery(filterValue, key)
      return additionalFilter;
    } 
    
  });
  
  return filterQueries.filter(q => q != null).join(" and ");
}

export function addSortingQuery(filterQuery, sorting)
{
  if(!sorting){
    return filterQuery;
  }
  if (filterQuery.length > 0) {
    filterQuery += "&";
  }
  const sortKeys = Object.keys(sorting);
  sortKeys.map((key) =>{

    const value = sorting[key];
    const sortValue = value.colId;
    const sortDirection = value.sort === "asc"? "": "-";
    
    filterQuery+='sort=' + sortValue + sortDirection + "&";

  })

  return filterQuery;
}

function handleResponse(response)
{
  if (!response.ok) {
    if (response.status === 401)
    {
      window.location.replace(config.AUTH_URL + "/Account/Login?ReturnUrl=" + encodeURIComponent(document.location.pathname));
    }
    else if (response.status === 403)
    {
      const error = new Error('Status Code: 403 Forbidden');
      error.status = 403;
      throw error;
    }
    else if(response.status === 404)
    {
      const error = new Error('Status Code: 404 Not Found');
      error.status = 404;
      throw error;
    } 
    else 
    {
      const error = new Error(`Status Code: ${response.status}`);
      error.status = response.status;
      window.location.replace(config.AUTH_URL + "/Account/Login?ReturnUrl=" + encodeURIComponent(document.location.pathname));
    }
  }
}

function createConditionQuery(filterValue, key){
  const comparator = filterValue.type;

  if(filterValue.filterType === "date")
  {
    const date = filterValue.dateFrom.split(' ')[0]
    var selectedDay = parseISO(date);
    const utcDayString = formatInTimeZone(selectedDay, 'UTC', "yyyy-MM-dd'T'HH:mm:ssXXX");
    
    const encodedFilter = encodeURIComponent(utcDayString);
    
    if(comparator === '<')
      return `${key}${comparator}${encodedFilter}`;
       
    var nextDay = addDays(selectedDay, 1);
    const nextUtcDayString = formatInTimeZone(nextDay, 'UTC',"yyyy-MM-dd'T'HH:mm:ssXXX");
    const encodedNextDay = encodeURIComponent(nextUtcDayString);

    if (comparator === '>')
      return `${key}>${encodedNextDay}`;
      
    if(comparator === '-'){      
      return `${key}<${encodedFilter} or ${key}>=${encodedNextDay}`;
    }

    if(comparator === ':'){
      return `${key}>=${encodedFilter} and ${key}<${encodedNextDay}`;
    }
  }
  else
  {
    const encodedFilter = encodeURIComponent(filterValue.filter);
    if(comparator == '-')
      return `${handleNotQuery(key, encodedFilter)}`;
    
    return `${key}${comparator}${encodedFilter}`
  }

}

function handleNotQuery(key, encodedFilter) {
  return `-${key}:"${encodedFilter}"`
}